'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modelsListToMap = exports.hasCredentialLoginData = exports.credentialsListToMapByGroupId = exports.compareCredentials = undefined;

var _immutable = require('immutable');

var _validator = require('@nettoken/validator');

var _validator2 = _interopRequireDefault(_validator);

var _Credential = require('./Credential');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {object} prev Credential model.
 * @param {object} next Credential model.
 * @param {object} options
 * @property {boolean} [allowSubset=false] Used in form filling to filter out
 * credentials that include all of the keys.
 * @property {boolean} [comparePassword=false]
 * @property {number} [lowerBounds=0.75]
 *
 * @returns {object}
 * @property {number} confidence
 * @property {boolean} match
 * @property {boolean} [subset] Defined if `allowSubset=true`
 */
var compareCredentials = exports.compareCredentials = function compareCredentials(prev, next, options) {
  var _Validator$ensureDefa = _validator2.default.ensureDefaults(options, {
    allowSubset: false,
    comparePassword: false,
    lowerBounds: 0.75,
    allowExtraInfo: true
  }),
      allowSubset = _Validator$ensureDefa.allowSubset,
      comparePassword = _Validator$ensureDefa.comparePassword,
      lowerBounds = _Validator$ensureDefa.lowerBounds,
      allowExtraInfo = _Validator$ensureDefa.allowExtraInfo;

  var attrs = comparePassword ? _Credential.DUPLICATE_ATTRIBUTES_WITH_PASSWORD : _Credential.DUPLICATE_ATTRIBUTES;
  var addedInfo = 0;
  var bothEmpty = 0;
  var different = 0;
  var exactMatches = 0;
  var notInSubset = 0;

  attrs.forEach(function (attr) {
    var prevValue = prev.get(attr).toUpperCase();
    var nextValue = next.get(attr).toUpperCase();
    if (!prevValue && !nextValue) {
      bothEmpty += 1;
    } else if (prevValue === nextValue) {
      exactMatches += 1;
    } else if (!prevValue && nextValue) {
      if (allowExtraInfo) {
        addedInfo += 1;
      }
    } else if (prevValue && !nextValue) {
      if (allowSubset) {
        notInSubset += 1;
      }
    } else {
      different += 1;
    }
  });

  var allMatches = bothEmpty + exactMatches + addedInfo + notInSubset;
  var confidence = (allMatches - (attrs.length - allMatches) * 1) / attrs.length;
  var res = {
    confidence: confidence,
    match: confidence >= lowerBounds
  };
  if (allowSubset) {
    res.subset = !addedInfo && !different;
  }
  return res;
};

/**
 * @param {List} credentials
 */
/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
var credentialsListToMapByGroupId = exports.credentialsListToMapByGroupId = function credentialsListToMapByGroupId(credentials) {
  return modelsListToMap(credentials, 'groupId');
};

/**
 * Check if the credential has set any login information.
 *
 * @param {object} credential
 *
 * @returns {boolean}
 */
var hasCredentialLoginData = exports.hasCredentialLoginData = function hasCredentialLoginData(credential) {
  for (var i = 0; i < _Credential.LOGIN_ATTRIBUTES.length; i += 1) {
    var key = _Credential.LOGIN_ATTRIBUTES[i];
    if (credential.get(key)) return true;
  }
  return false;
};

/**
 * Transforms an array or List of models into an immutable Map, grouping them
 * by the selected model attribute.
 *
 * @param {List} list
 * @param {string} groupBy
 */
var modelsListToMap = exports.modelsListToMap = function modelsListToMap() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.List();
  var groupBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

  var map = new _immutable.Map();
  list.forEach(function (model) {
    var key = model.get(groupBy);
    if (!map.get(key)) {
      var defaultValue = new _immutable.List();
      map = map.set(key, defaultValue);
    }
    var currentValue = map.get(key);
    var nextValue = currentValue.push(model);
    map = map.set(key, nextValue);
  });
  return map;
};